import { Location } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuditsModel } from '../audits.model';
import { AuditsService } from '../audits.service';
import { ActivatedRoute } from '@angular/router';
import { RBACService } from 'src/app/shared/rbac.service';

@Component({
  selector: 'app-audits-templates-view',
  templateUrl: './audits-templates-view.component.html',
  styleUrls: ['./audits-templates-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AuditsTemplatesViewComponent implements OnInit {
  audit: AuditsModel = new AuditsModel();
  displayedColumns = ['name', 'section'];

  constructor(
    private service: AuditsService,
    private route: ActivatedRoute,
    public location: Location,
    public rbac: RBACService
  ) {}

  ngOnInit() {
    // 1. Check view permission: redirect back if denied.
    const canView = this.rbac.userCanAccess(
      [
        RBACService.getPermission(
          RBACService.RBAC_F.F_TEMPLATES_INSPECTIONS_AUDITS,
          RBACService.RBAC_A.A_VIEW
        )
      ],
      true
    );

    if (!canView) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to view inspection/audit templates.'
      );
      this.location.back();
      return;
    }

    // 2. Load template data.
    this.service
      .find(this.route.snapshot.params['id'])
      .subscribe((response) => (this.audit = response.data));
  }
}
